import React from 'react';
import { View, Text, TouchableOpacity, Modal } from 'react-native';
import Icon from '../Icon';

import styles from './styles';
/**
 * @discription:  基于Modal二次开发
 * @param {Object} props = { }  //必传
 * @param {Boolean} props.visible = false,   //必传
 * @param {String} props.title = '弹框',   //非必传
 * @param {String} props.msg = //非必传
 * @param {String} props.htmlView = '请在此确认是否执行此操作',   //非必传
 * @param {String} props.okText = '确定',   //非必传
 * @param {Function} props.onOk = onOk, //必传
 * @param {Object} props.style = style //非必传 重置弹框外层样式
 * @return:
 */

const Dialog = (props: any) => {
  const {
    visible = false,
    title = '消息',
    msg = '',
    okText = '确定',
    header = true,
    onOk,
    htmlView
  } = props || {};
  return (
        <Modal
            animationType='fade'
            transparent
            visible={visible}
            onRequestClose={onOk}
            presentationStyle='overFullScreen'
        >
            <TouchableOpacity
                style={styles.mask}
                activeOpacity={1}
                onPress={onOk}
            />
            <View style={styles.modalMain}>
                <TouchableOpacity onPress={onOk} style={styles.closeWrapper}>
                    <Icon size={20} name='maskClose' color='#999' />
                </TouchableOpacity>
                {/* 标题 */}
                {
                    header && title !== ''
                      ? <Text style={styles.modalTitle}>{title}</Text>
                      : null
                }
                {/* 提示信息 */}
                <View style={styles.modalInfo}>
                    {
                        htmlView || null
                    }
                    {
                        msg
                          ? <Text style={styles.modalInfoText}>{msg}</Text>
                          : null
                    }
                </View>
                {/* 按钮 */}
                <TouchableOpacity onPress={onOk} style={styles.modalBottom}>
                    <Text style={styles.btn}>{okText}</Text>
                </TouchableOpacity>
            </View>
        </Modal>
  );
};

export default Dialog;
